import { useState } from "react";
import { useParams } from "react-router-dom";
import useLabels from "../../../hooks/useLabels";
import FlowChart from "../FlowChart";
import Loader from "../../Loader";
import TrackingOperationDetail from "./TrackingOperationDetail";

import "./styles/index.scss";

const TrackingTree = ({
  type = "tank",
  traceData = [],
  isLoading,
  batchParentIds = [],
}) => {
  const { id } = useParams();
  const [getLabel] = useLabels();
  const [isShowOperationData, setIsShowOperationData] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [operationData, setOperationData] = useState({});
  
  const toggleShowOperationData = (operation_id) => {
    const opDetail =
      traceData?.find((o) => o?.operation_id === operation_id) || null;
    if (opDetail) {
      setIsClosing(false);
      setIsShowOperationData(true);
      setOperationData(opDetail);
    }
  };

  const closeAdditionalInfo = () => {
    setIsClosing(true); // trigger CSS hide animation
    setTimeout(() => {
      setIsShowOperationData(false); // unmount panel
      setOperationData(null);
      setIsClosing(false); // reset closing state for future opens
    }, 300); // match with CSS transition duration
  };

  const renderTrackingTree = () => {
    return (
      <div className="primary_container_menu_wrapper">
        <div className="primary_container_menu">
          <div className="panel-wrapper">
            <div className="left-panel">
              {isLoading && (
                <div className="loader_wrapper">
                  <Loader />
                </div>
              )}
              {!isLoading && traceData?.length === 0 && (
                <h5 className="alert_no_info">
                  {getLabel("tankTrackingTreeNoData")}
                </h5>
              )}
              {!isLoading && traceData?.length > 0 && (
                <FlowChart
                  operations={traceData}
                  toggleShowOperationData={toggleShowOperationData}
                  flowType={type}
                  id={id}
                  batchParentIds={batchParentIds}
                />
              )}
              {/* </ReactFlowProvider> */}
            </div>
            {(isShowOperationData || isClosing) && (
              <div className="right-panel">
                <TrackingOperationDetail
                  operation={operationData}
                  closeAdditionalInfo={closeAdditionalInfo}
                  isClosing={isClosing}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  return renderTrackingTree()
};

export default TrackingTree;
